import { join, go, html, strMap } from 'fxjs/es';
import { NessAppPlusHomeTmplS } from './module/NessAppPlusHomeTmplS.js';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { NessCoreConstantS } from '../../../../../Core/S/Constant/module/NessCoreConstantS.js';
import { NessAppPlusProductTmplS } from '../../../Product/S/Tmpl/module/NessAppPlusProductTmplS.js';
import { CUSTOM_IMAGE_FOLDER_NAME } from '../../../../../../MShop/App/Product/Item/S/Constant/item.js';
import {
  NESS_CUSTOM_ASSET_PRODUCT_LIST_URL,
  NESS_CUSTOM_USER_PRODUCT_LIST_URL,
} from '../../../../../S/Constant/custom.js';
import { NessAppPlusProductS } from '../../../Product/S/Function/module/NessAppPlusProductS.js';
import { isLabsOpened } from '../../../../../../NessLabs/S/Function/deploy.js';

export const customProduct = (
  custom_products,
  { is_mobile, menu_name_kr, menu_name_en, is_show_home_list, is_show_banner, custom_banners },
) => {
  const custom_filter_menu_data = NessAppPlusProductS.getCustomAssetProductMenuList(custom_products);

  return html`
    <div class="ness-custom-product__asset">
      ${NessAppPlusHomeTmplS.homeTitle({
        link: isLabsOpened() ? NESS_CUSTOM_USER_PRODUCT_LIST_URL() : NESS_CUSTOM_ASSET_PRODUCT_LIST_URL,
        title: menu_name_en,
        sub_title: menu_name_kr,
        title_color: NessCoreConstantS.colors.black,
        sub_title_color: NessCoreConstantS.colors.black,
      })}
      ${is_show_home_list
        ? html`
            <div class="ness-custom-product__asset__home-list">
              <div class="ness-custom-product__asset__home-list__side-menu">
                ${is_show_home_list
                  ? customProductsCategory('ness-custom-product__asset__home-list__side-menu')(
                      custom_filter_menu_data,
                      true,
                    )
                  : ''}
              </div>
              <div class="ness-custom-product__asset__home-list__product-container swiper-container">
                <div class="ness-custom-product__asset__home-list__product-container__items swiper-wrapper">
                  ${strMap((product) => {
                    return html`
                      ${NessAppPlusProductTmplS.nessProductLazyLoadTmpl(product, is_mobile, 'swiper-slide')}
                    `;
                  }, custom_products)}
                </div>
              </div>
            </div>
          `
        : ``}
      ${is_show_banner
        ? html`
            <div class="ness-custom-product__banner">
              ${strMap((banner) => {
                const img_tmpl = html`<img
                  src="${is_mobile ? banner.img_url_mo : banner.img_url}"
                  alt="${banner.alt_text}"
                />`;
                return html`<div class="ness-custom-product__banner__image">
                  ${(() => {
                    if (UtilS.isNotEmpty(banner.link_url) && !banner.is_disabled) {
                      return html` <a href="${banner.link_url}"> ${img_tmpl} </a> `;
                    } else {
                      return img_tmpl;
                    }
                  })()}
                </div>`;
              }, custom_banners)}
            </div>
          `
        : ''}
    </div>
  `;
};

export const customProductsCategory = (className) => (custom_filter_menu_data, show_quantity) => {
  return html`
    <ul class="${className}__category">
      ${go(
        custom_filter_menu_data,
        strMap(({ asset_folder_name, display_name, length, selected }) => {
          const selected_class = selected ? 'selected' : '';
          return html`
            <li
              class="${className}__category__item ${selected_class}"
              data-${CUSTOM_IMAGE_FOLDER_NAME}="${asset_folder_name}"
            >
              <span class="folder-name">${display_name}</span>
              ${show_quantity ? html`<span class="quantity">${length}</span>` : ''}
            </li>
          `;
        }),
        join(''),
      )}
    </ul>
  `;
};
